import { IntlShape } from 'react-intl';
import { FYMAPIError } from 'fym-common/src/generics/errors/FYMAPIError';
import { ErrorAPIResult } from '../../../../redux/api/utils/isSuccessfulResult';

/**
 * The sentence an API error shows: the custom message, else the server's message for an
 * operational error, else the general one. ErrorAlert and ConfirmDialog use the same text.
 */
export function errorAlertMessage(
  intl: IntlShape,
  error: ErrorAPIResult['error'] | undefined,
  customMessage?: string
): string {
  if (customMessage !== undefined && customMessage !== '') {
    return customMessage;
  }
  if (error instanceof FYMAPIError && error.isOperational) {
    return error.message;
  }
  return intl.formatMessage({
    id: 'app.errors.fym_api.default',
    defaultMessage: `Something went wrong. Please try again, and if the problem persists, contact support@music24.com.`,
  });
}
